import { render, staticRenderFns } from "./Goal.vue?vue&type=template&id=51412e8a&scoped=true&"
import script from "./Goal.vue?vue&type=script&lang=js&"
export * from "./Goal.vue?vue&type=script&lang=js&"
import style0 from "./Goal.vue?vue&type=style&index=0&id=51412e8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51412e8a",
  null
  
)

export default component.exports